"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const dialog_1 = tslib_1.__importDefault(require("../assets/scripts/dialog"));
const __sfc_main = {};
__sfc_main.props = {
    src: {
        key: "src",
        required: true,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { visible, show, hide } = (0, dialog_1.default)('dialog-zoom');
    const props = __props;
    return Object.assign({
        visible,
        hide,
        props
    }, {
        show,
        hide
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9nLXpvb20udnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZGlhbG9nLXpvb20udnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVVBLDhFQUFpRDtBQUNqRCxNQUFNLFVBQVUsR0FBRyxFQUFFLENBQUM7QUFDdEIsVUFBVSxDQUFDLEtBQUssR0FBRztJQUNqQixHQUFHLEVBQUU7UUFDSCxHQUFHLEVBQUUsS0FBSztRQUNWLFFBQVEsRUFBRSxJQUFJO1FBQ2QsSUFBSSxFQUFFLE1BQU07S0FDYjtDQUNGLENBQUM7QUFDRixVQUFVLENBQUMsS0FBSyxHQUFHLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxFQUFFO0lBQ3BDLE1BQU0sRUFDSixPQUFPLEVBQ1AsSUFBSSxFQUNKLElBQUksRUFDTCxHQUFHLElBQUEsZ0JBQVMsRUFBQyxhQUFhLENBQUMsQ0FBQztJQUM3QixNQUFNLEtBQUssR0FBRyxPQUFPLENBQUM7SUFDdEIsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ25CLE9BQU87UUFDUCxJQUFJO1FBQ0osS0FBSztLQUNOLEVBQUU7UUFDRCxJQUFJO1FBQ0osSUFBSTtLQUNMLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUNGLGtCQUFlLFVBQVUsQ0FBQyJ9